import { SugarPageAction } from "../Types";

import { PageAction } from "./PageActions";

export function mapPageActionsByProps(
    pageActionProps: { [actionName: string]: SugarPageAction } = {},
    defaultPageActions: { [actionName: string]: PageAction }
): PageAction[] {
    return Object.entries(defaultPageActions)
        .filter(([actionName]) => !(pageActionProps[actionName]?.hideAction ?? false))
        .map(([actionName, defaultAction]) => {
            const fromSugarAction = pageActionProps[actionName];

            return fromSugarAction
                ? {
                      "data-tid": defaultAction["data-tid"],
                      description: fromSugarAction.description || defaultAction.description,
                      handler: defaultAction.handler,
                      disabled: fromSugarAction.disableAction || defaultAction.disabled,
                  }
                : defaultAction;
        });
}
